module.exports = __webpack_public_path__ + "static/media/discover.62706277.png";